import {
  type OddsOfEligibility,
  useTrialApplication,
} from '@components/hooks/TrialApplicationQuestionnaireProvider/index.client'
import Tachometer from '@components/primitives/Tachometer'
import { Text } from '@components/primitives/Text'
import getParsedEligibilityCriteriaForTrial from '@modules/trials/helpers/parseEligibilityCriteria/getParsedEligibilityCriteriaForTrial'
import { type TrialAssociation } from '@modules/trials/types/TrialAssociation'
import { useEffect, useState } from 'react'

export const CriteriaMetTachometer = ({
  animate = true,
  trial,
}: {
  animate?: boolean
  trial: TrialAssociation
}) => {
  const { getOddsOfEligibility } = useTrialApplication()
  const criteria = getParsedEligibilityCriteriaForTrial(trial)

  const [oddsOfEligibility, setOddsOfEligibility] = useState<
    OddsOfEligibility | undefined
  >()

  useEffect(() => {
    setOddsOfEligibility(getOddsOfEligibility(trial.slug))
  }, [getOddsOfEligibility])

  const startingPercentage = animate
    ? (oddsOfEligibility?.prevPercent ?? 0) / 100
    : (oddsOfEligibility?.percent ?? 0) / 100

  const denominator = criteria.length
  const isEmpty = denominator === 0

  const title = isEmpty
    ? 'Do I qualify?'
    : `${oddsOfEligibility?.criteriaMet ?? 0} / ${denominator}`
  const subtitle = isEmpty
    ? 'Apply below to find out'
    : 'Eligibility criteria met'
  const percentage = isEmpty
    ? 0.3
    : (oddsOfEligibility?.criteriaMet ?? 0) / denominator

  return (
    <div className='relative flex justify-center'>
      <div className='absolute left-0 top-1/3 flex h-[100px] w-full flex-col justify-center text-center'>
        <Text className='line-clamp-2' styleName='h4' value={title} />
        <Text
          className='text-neutral600'
          styleName='p-small'
          value={subtitle}
        />
      </div>
      <Tachometer
        duration={1000}
        height={300}
        percentage={percentage}
        startingPercentage={startingPercentage}
        valueColor='success400'
        width={300}
      />
    </div>
  )
}
